<template>
  <TransitionGroup
    name="dynamic-list"
    tag="ul"
    class="dynamic-list"
    @before-leave="beforeLeave"
    @leave="leave"
    @after-leave="afterLeave"
  >
    <li v-for="(item, idx) in value" :key="item.id ?? idx">
      <slot
        :item="item"
        :index="idx"
        :onMoveUp="moveUp"
        :onMoveDown="moveDown"
        :onMoveTop="moveTop"
        :onMoveBottom="moveBottom"
        :onRemove="remove"
      />
    </li>
  </TransitionGroup>
</template>
<script>
export default {
  props: ['value'],
  methods: {
    moveUp(index) {
      if (!this.value || index <= 0 || index >= this.value.length) {
        return
      }

      const temp = this.value[index]
      this.$set(this.value, index, this.value[index - 1])
      this.$set(this.value, index - 1, temp)

      this.$emit('change')
    },
    moveDown(index) {
      if (!this.value || index >= this.value.length - 1) {
        return
      }

      const temp = this.value[index]
      this.$set(this.value, index, this.value[index + 1])
      this.$set(this.value, index + 1, temp)

      this.$emit('change')
    },
    moveTop(index) {
      if (!this.value || index <= 0) {
        return
      }

      const item = this.value.splice(index, 1)[0]
      this.value.unshift(item)

      this.$emit('change')
    },
    moveBottom(index) {
      if (!this.value || index >= this.value.length - 1) {
        return
      }

      const item = this.value.splice(index, 1)[0]
      this.value.push(item)

      this.$emit('change')
    },
    remove(index) {
      if (!this.value) {
        return
      }

      const item = this.value[index]

      this.value.splice(index, 1)

      this.$emit('change', { action: 'remove', item: { ...item } })
    },
    beforeLeave(el) {
      el.style.height = el.offsetHeight + 'px'
      el.style.marginTop = getComputedStyle(el).marginTop
      el.style.opacity = '1'
      el.style.transform = 'translateX(0)'
    },
    leave(el, done) {
    // Прозрачность и слайд
      requestAnimationFrame(() => {
        el.style.transition = 'opacity 0.3s ease, transform 0.3s ease'
        el.style.opacity = '0'
        el.style.transform = 'translateX(20px)'

        // После завершения проразчности и слайда, делаем переход до высоты 0
        setTimeout(() => {
          el.style.transition = 'height 0.3s ease'
          el.style.height = '0'
          el.style.marginTop = '0'
        }, 300)

        // Завершаем анимацию
        setTimeout(() => {
          done()
        }, 600)
      })
    },
    afterLeave(el) {
    // Очистка стилей
      el.style.height = ''
      el.style.marginTop = ''
      el.style.opacity = ''
      el.style.transform = ''
      el.style.transition = ''
    },
  },
}
</script>
<style>
.dynamic-list {
  gap: 16px;
  position: relative;
  list-style: none;
  padding: 0;
  margin-bottom: 0;
}

.dynamic-list li:not(:first-child) {
  margin-top: 16px;
}

.dynamic-list-move,
.dynamic-list-enter-active,
.dynamic-list-leave-active {
  transition: all 0.5s ease;
}

.dynamic-list-enter,
.dynamic-list-leave-to {
  opacity: 0;
  transform: translateX(30px);
}
</style>
